import { render, staticRenderFns } from "./SysMessageTestModal.vue?vue&type=template&id=6d15a1ff&scoped=true"
import script from "./SysMessageTestModal.vue?vue&type=script&lang=js"
export * from "./SysMessageTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15a1ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d15a1ff')) {
      api.createRecord('6d15a1ff', component.options)
    } else {
      api.reload('6d15a1ff', component.options)
    }
    module.hot.accept("./SysMessageTestModal.vue?vue&type=template&id=6d15a1ff&scoped=true", function () {
      api.rerender('6d15a1ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/message/modules/SysMessageTestModal.vue"
export default component.exports